import { useAuth } from "hooks/auth";
import { querystring } from "models/Listing";
import useSWR from "swr";
import { ListingProps } from "types/listing";
import { getEnvVariable } from "utilities/env";

export const useReports = () => {
  const { fetcher } = useAuth();

  const useBillableReport = (props?: ListingProps) => {
    return useSWR(
      () =>
        `${getEnvVariable("REACT_APP_API_URL")}/billable-report${querystring(
          props,
        )}`,
      fetcher,
    );
  };

  return {
    useBillableReport,
  };
};
